import React, { useEffect } from 'react';
import GoogleMap from './GoogleMaps';
import convexHull from './ConvexHull';
import ConnectionFinder from '../api/ConnectionFinder';
import AutocompleteCustom from './AutoCompleteCustom';
import Navbar from './Navbar';
import NavButton from './NavButton';
import { useGridApiRef } from '@mui/x-data-grid';
import Cookie from './Cookies';
import Loading from './Loading';
import { DataGrid } from '@mui/x-data-grid';
import ColumnsFibre from './ColumnsFibre';
import "./styles/Fibre.css"
import closepng from "./img/close.png"
var OpenLocationCode = require('open-location-code').OpenLocationCode;
const FibreConnect = () => {
  const apiRef = useGridApiRef();
  const [markerCoords, setMarkerCoords] = React.useState([]);
  const [finalcoors, setFinalCoors] = React.useState([]);
  const [Local, setLocal] = React.useState([])
  const [Address, setAddress] = React.useState([])
  const [Civic, setCivic] = React.useState([])
  const [rows, setRows] = React.useState([]);
  const [TextLocation, setTextLocation] = React.useState("");
  const [TextAddress, setTextAddress] = React.useState("");
  const [TextCivic, setTextCivic] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [ResearchBy, setResearchBy] = React.useState("Comune");
  const FetchLocation = async (e) => {
    ConnectionFinder.get("/research/fibreconnect/GetLocations", { headers: { "x-access-token": localStorage.getItem('token') } }).then((response) => {
      const arr = []
      for (const element of response.data) {
        arr.push(element.Area_Industriale)
      }
      arr.sort((a, b) => a.localeCompare(b))
      setLocal(arr)
    })
  }
  const Reset = () => {
    setTextLocation("")
    setLocal([])      
    setTextAddress("")
    setAddress([])
    setCivic([])
    setTextCivic("")
  }
  const FetchCoords = async () => {
    setLoading(true)
    let param = {}
    if (document.getElementById("Area_Industriale").value === ""){
      alert("Devi inserire almeno il comune o l'area industriale")
      return
    }
    if (ResearchBy === "Comune")
      param = { city : document.getElementById("Area_Industriale").value }
    else if (ResearchBy === "Area Industriale/Comune")
      param = { both : document.getElementById("Area_Industriale").value }
    else
      param = { local: document.getElementById("Area_Industriale").value}
    param["address"] = document.getElementById("IndirizzoFibre").value
    param["civic"] = document.getElementById("CivicoFibre").value
    ConnectionFinder.get("/research/fibreconnect/LocationData",
      {
        params: param, headers: { "x-access-token": localStorage.getItem('token') }
      }).then((response) => {
        const PlusCodes = [];
        var coordinates = [];
        response.data.forEach((element) => {
          PlusCodes.push([element.plusCODE, element.Indirizzo + " " + element.Numero_Civico]);
        })
        setRows(response.data)
        PlusCodes.forEach((code) => {
          const olc = new OpenLocationCode();
          const codeArea = olc.decode(code[0]);
          coordinates.push([codeArea.latitudeCenter, codeArea.longitudeCenter, code[1]]);
        })
        setMarkerCoords(coordinates)
        const points = convexHull(coordinates)
        const newCoords = []
        points.forEach((point) => {
          newCoords.push({ lat: point[0], lng: point[1] });
        });
        setFinalCoors(newCoords);
        setLoading(false)
      })
  }

  const FetchCities = async () => {
    if (ResearchBy !== "Comune"){
      FetchLocation()
      return  
    }
    const value = document.getElementById("Area_Industriale").value
    if (value.length < 3) return 
    let headers = {
      "x-access-token": localStorage.getItem('token')
    }
    ConnectionFinder.post("/research/fibercop/city", {
      name: value,
    },{headers}).then((response) => {
      if (response.data.status === false) return
      const arr = []
      for (const element of response.data) {
        arr.push(element.Denominazione_in_italiano)
      }
      arr.sort((a, b) => {return a.length > b.length ? 1 : -1})
      setLocal(arr)
    })
  }

  const GetAdresses = async () => {
    let value = document.getElementById("IndirizzoFibre").value
    const data = await ConnectionFinder.get("/research/fibreconnect/GetAddresses", { params: { local: document.getElementById("Area_Industriale").value, address: value }, headers: { 'x-access-token': localStorage.getItem('token') } })
    const arr = []
    for (const element of data.data) {
      arr.push(element.Indirizzo)
    }
    arr.sort((a, b) => a.localeCompare(b))
    setAddress(arr)
  }

  const GetCivics = async () => {
    setTextCivic("")
    let value = document.getElementById("CivicoFibre").value
    const data = await ConnectionFinder.get("/research/fibreconnect/GetCivics", { params: { local: document.getElementById("Area_Industriale").value, address: document.getElementById("IndirizzoFibre").value, civic: value }, headers: { "x-access-token": localStorage.getItem('token') } })
    const arr = []
    for (const element of data.data) {
      arr.push(element.Numero_Civico)
    }
    arr.sort((a, b) => a.localeCompare(b))
    setCivic(arr)
  }
  useEffect(() => {
    if (ResearchBy === "Area Industriale"){
      setLocal([])
      setAddress([])
      setCivic([])
      setTextLocation("")
      FetchLocation()
    }
    else{
      setLocal([])
      setAddress([])
      setCivic([])
    }
  }, [ResearchBy])

  const decheck = (e) => {
    if (e.target.checked) {
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => {
        if (checkbox !== e.target) {
          checkbox.checked = false;
        }
      });
    }
    if (!e.target.checked){
      e.target.checked = true
      return
    }

    if (e.target.id === "ByComune") {
      setResearchBy("Comune")

    }
    else if (e.target.id === "ByBoth"){
      setResearchBy("Area Industriale/Comune")
    }
    else{
      setResearchBy("Area Industriale")
      setTextLocation("")
      setLocal([])   
    }
    Reset()
      
  }

  const TipoRicerca = (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: 'fit-content', backgroundColor: 'white', paddingBottom: '5px', gap: '8px', paddingTop: '10px' }}>
      <span style={{ fontSize: '25px', fontWeight: 'bold', marginLeft: '15px', color: 'grey' }}>Ricerca da:</span>
      <div style={{ marginLeft: '30px' }}>
        <div className='researchFilters'>
          <div >
            <label htmlFor="ByComune" style={{ fontSize: "20px", }}>Comune</label>
            <input defaultChecked type="checkbox" name="ByComune" id="ByComune" style={{ marginLeft: '15px', accentColor: "#ff0f64", transform: "scale(1.5)" }} onClick={(e) => decheck(e)} />
          </div>
          <div>
            <label htmlFor="ByArea_Industriale" style={{ fontSize: "20px" }}>Area Industriale</label>
            <input type="checkbox" name="ByArea_Industriale" id="ByArea_Industriale" style={{ marginLeft: '15px', accentColor: "#ff0f64", transform: "scale(1.5)" }} onClick={(e) => decheck(e)} />
          </div>
          <div>
            <label htmlFor="ByBoth" style={{ fontSize: "20px" }}>Entrambe</label>
            <input type="checkbox" name="ByBoth" id="ByBoth" style={{ marginLeft: '15px', accentColor: "#ff0f64", transform: "scale(1.5)" }} onClick={(e) => decheck(e)} />
          </div>
        </div>
      </div>
    </div>
  )
  return (
    <div style={{ background: 'linear-gradient(347deg, rgba(243,17,98,0.927608543417367) 8%, rgba(41,44,59,1) 61%)', paddingBottom: '30px'}}>
      <Navbar />
      <div className='titleBar'><h1 style={{ color: '#ff0f64', fontSize: '2rem', margin: 0, marginLeft: '10px'}}>Ricerca FibreConnect</h1></div>
      {TipoRicerca}
      <div className='InputContainerOF'>
        <AutocompleteCustom suggestions={Local} value={TextLocation} setvalue={setTextLocation} onTextChange={FetchCities} onSelect={() => GetAdresses()} label={ResearchBy} id="Area_Industriale" className="AutoCompleteFibre" />
        <AutocompleteCustom suggestions={Address} value={TextAddress} setvalue={setTextAddress} onSelect={() => GetCivics()} label="Indirizzo" id="IndirizzoFibre" className="AutoCompleteFibre" />
        <AutocompleteCustom suggestions={Civic} value={TextCivic} setvalue={setTextCivic} label="Civico" id="CivicoFibre" className="AutoCompleteFibre" />
        <div className='btn' style={{ width: '85%' }} onClick={() => FetchCoords()}>Cerca</div>
      </div>
      <NavButton text="Indietro" to="/home" />
      <p style={{ color: 'white', fontWeight: 'bold', fontSize: '40px', margin: '0', textAlign: 'center', marginBottom: '6px' }}>Risultati</p>
      {loading ? <Loading /> : <div className='grid' >
        <DataGrid
          rows={rows}
          column
          columns={ColumnsFibre}
          apiRef={apiRef}
          getRowId={(row) => row.Id}
        />

      </div>}
      {
        rows.length === 0 ? <></> :
          <div className='btn actionButton only' style={{marginTop: '2vh', marginRight: '30px' }} onClick={() => document.getElementById("MapModal").showModal()}>Mostra Mappa</div>
      }
      <dialog className='dialogmap' id='MapModal'>
        <img src={closepng} alt='CloseDialog' id='CloseDialog' onClick={() => document.getElementById("MapModal").close()} style={{ cursor: 'pointer'}} />
        {markerCoords.length === 0 && finalcoors.length === 0 ? <p style={{ color: 'white', fontSize: '20px', textAlign: 'center' }}>Nessun risultato trovato</p> :
          <GoogleMap markerCoords={markerCoords} coordinates={finalcoors} address={rows} />
        }
      </dialog>
      <Cookie />
    </div>
  );
}
export default FibreConnect;
